<template>
    <div class="consent-info">
        <div class="consent-info-head">
            Szanujemy Twoją prywatność
        </div>
        <div
            class="consent-info-text">
            Używamy plików cookies w&nbsp;celu zapewnienia funkcjonalności oraz optymalnego działania naszych stron
            internetowych, zarządzania preferencjami, analizy zasięgu i&nbsp;wyszukiwania, a&nbsp;także w&nbsp;celu
            wyświetlania i&nbsp;oceny spersonalizowanych treści i&nbsp;reklam.<br>
            Klikając „Zgadzam się” wyrażasz zgodę na stosowanie wszystkich plików cookies. W&nbsp;dowolnym momencie
            możesz samodzielnie zarządzać ustawieniami plików cookies oraz dostosować je do swoich preferencji, klikając
            <button
                @click="onSettings"
                v-text="'tutaj.'"
            />
        </div>
        <div class="consent-info-accept">
            <button
                :class="['btn btn-submit btn-submit--no-arrow', { 'is-dimmed': loading }]"
                @click="onAccept"
                v-text="'Zgadzam się'"
            />
            <Loader :is-active="loading" class="cookies-info-accept-loader" />
        </div>
    </div>
</template>

<script>
import ApiHub from '@/api/ApiHub'
import Loader from '@/components/loader/Loader'
import UuidMixin from '@/mixins/UuidMixin'
import { mapMutations } from 'vuex'

export default {
    mixins: [UuidMixin],
    components: {
        Loader
    },
    data() {
        return {
            defaultCookiesTypes: {
                necessary: true,
                functional: true,
                efficiency: true,
                advertising: true
            },
            loading: false,
        }
    },
    methods: {
        ...mapMutations([
            'setCookiesTypes'
        ]),
        onAccept() {
            this.loading = true
            let uuid = this.create_UUID()
            ApiHub.postCookieConsents(Object.assign({}, this.defaultCookiesTypes, {
                sessionId: uuid,
                site: "Foodlovers"
            }))
                .then(() => {
                    this.setCookiesTypes(this.defaultCookiesTypes)
                    window.localStorage.setItem(
                        'cookiesTypes',
                        JSON.stringify(this.defaultCookiesTypes)
                    )
                    window.localStorage.setItem('cookiesAcceptedUuid', uuid)
                })
                .catch(e => {
                    console.log("Błąd zapisu zgód cookies")
                    console.log(e)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onSettings() {
            this.$emit('onSettings')
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/_variables/color';

.consent-info {
    max-width: 370px;
    padding: 24px 30px 19px;
    box-sizing: border-box;

    &-head {
        color: $color-primary;
        font-size: 20px;
        line-height: 28px;
        font-weight: bold;
        margin-bottom: 22px;
    }

    &-text {
        font-size: 14px;
        line-height: 22px;
        color: $color-default;
        margin-bottom: 23px;

        button {
            border: none;
            background: none;
            color: $color-default;
            line-height: 26px;
            font-weight: bold;
            text-align: center;
            outline: 0;
            cursor: pointer;
            padding: 0;
            transition: color 0.2s;

            &:hover {
                color: $color-default-lighter;
            }
        }
    }

    &-accept {
        position: relative;
        margin-bottom: 10px;

        button {
            font-size: 18px;

            &.is-dimmed {
                opacity: 0.1;
                pointer-events: none;
            }
        }

        &-loader {
            position: absolute;
            top: 8px;
            left: calc(50% - 27px);
            transform-origin: 0 0;
        }
    }

    &-settings {
        font-size: 1.4rem;
        line-height: 1.4rem;
    }

    @media (max-width: 640px) {
        padding: 12px 15px 9px;

        &-head {
            margin-bottom: 15px;
            line-height: 20px;
        }

        &-text {
            font-size: 15px;
            line-height: 21px;
            margin-bottom: 20px;
        }

        &-accept {
            margin-bottom: 16px;
        }
    }
}
</style>
